import { ShieldCheck } from "lucide-react";
import {
  ACCESS_CATALOG,
  ACCESS_ROLES,
  setModuleAccess,
} from "../access/policy";
export default function PermissionsEditor({
  value,
  onChange,
  role,
  owner = false,
  disabled = false,
}) {
  const groups = [...new Set(ACCESS_CATALOG.map((module) => module.group))];
  const change = (module, actions) =>
    onChange(setModuleAccess(value, module, actions));
  const mode = (module) => {
    const current = value.modules[module.id] || [];
    return !current.length
      ? "none"
      : current.length === 1 && current[0] === "read"
        ? "read"
        : current.length === Object.keys(module.actions).length
          ? "full"
          : "custom";
  };
  const toggle = (module, action, checked) => {
    const actions = new Set(value.modules[module] || []);
    if (checked) {
      actions.add(action);
      actions.add("read");
    } else {
      actions.delete(action);
      if (action === "read") actions.clear();
    }
    change(module, [...actions]);
  };
  return (
    <div className="team-permissions">
      <div className="team-permission-intro">
        <div>
          <strong>
            Permisos de {(ACCESS_ROLES[role] || "Personalizado").toLowerCase()}
          </strong>
          <p className="team-help">
            Define qué puede consultar y hacer en cada módulo.
          </p>
        </div>
        <span className="team-badge">
          <ShieldCheck size={14} />
          Solo en este consultorio
        </span>
      </div>
      <div className="team-fields">
        <label>
          Alcance de pacientes
          <select
            aria-label="Alcance de pacientes"
            value={value.patientScope}
            disabled={disabled || owner}
            onChange={(e) =>
              onChange({ ...value, patientScope: e.target.value })
            }
          >
            <option value="all">Todos los del consultorio</option>
            <option value="assigned">Solo pacientes asignados</option>
          </select>
        </label>
        <label>
          Alcance de agenda
          <select
            aria-label="Alcance de agenda"
            value={value.agendaScope}
            disabled={disabled || owner}
            onChange={(e) =>
              onChange({ ...value, agendaScope: e.target.value })
            }
          >
            <option value="team">Agenda de todo el equipo</option>
            <option value="own">Solo agenda propia</option>
          </select>
        </label>
      </div>
      <div className="team-permission-groups">
        {groups.map((group, index) => (
          <details
            key={group}
            open={index === 0 || undefined}
            className="team-permission-group"
          >
            <summary>
              {group}
              <small>
                {ACCESS_CATALOG.filter((m) => m.group === group).length} áreas
              </small>
            </summary>
            {ACCESS_CATALOG.filter((module) => module.group === group).map(
              (module) => {
                const actions = value.modules[module.id] || [];
                return (
                  <div className="team-permission-module" key={module.id}>
                    <span>
                      {module.label}
                      {owner && <small>Acceso de propietaria/o</small>}
                    </span>
                    <select
                      aria-label={"Acceso a " + module.label}
                      value={mode(module)}
                      disabled={disabled || owner}
                      onChange={(e) => {
                        const option = e.target.value;
                        if (option === "custom") {
                          e.target
                            .closest(".team-permission-module")
                            .querySelector("details").open = true;
                          return;
                        }
                        change(
                          module.id,
                          option === "none"
                            ? []
                            : option === "read"
                              ? ["read"]
                              : Object.keys(module.actions),
                        );
                      }}
                    >
                      <option value="none">Sin acceso</option>
                      <option value="read">Solo lectura</option>
                      <option value="full">Completo</option>
                      <option value="custom">Personalizado</option>
                    </select>
                    <details>
                      <summary>
                        Acciones específicas · {actions.length}/
                        {Object.keys(module.actions).length}
                      </summary>
                      <div className="team-action-checks">
                        {Object.entries(module.actions).map(([key, label]) => (
                          <label key={key}>
                            <input
                              type="checkbox"
                              checked={actions.includes(key)}
                              disabled={disabled || owner}
                              onChange={(e) =>
                                toggle(module.id, key, e.target.checked)
                              }
                            />
                            {label}
                          </label>
                        ))}
                      </div>
                    </details>
                  </div>
                );
              },
            )}
          </details>
        ))}
      </div>
      <p className="team-help">
        VexaDent AI respeta estos permisos. Agenda, cobros y expediente
        necesitan los datos básicos del paciente; alineadores necesita ver los
        STL.
      </p>
    </div>
  );
}
